var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCouponSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 0v.75C18 1.99 19.01 3 20.25 3H21v7.5h-.75c-1.24 0-2.25 1.01-2.25 2.25v.75H3v-.75C3 11.51 1.99 10.5.75 10.5H0V3h.75C1.99 3 3 1.99 3 .75V0h15Zm-1.424 1.5H9V3H7.5V1.5H4.424v.003A3.774 3.774 0 0 1 1.5 4.418v4.664A3.774 3.774 0 0 1 4.424 12H7.5v-1.5H9V12h7.576A3.778 3.778 0 0 1 19.5 9.076V4.424A3.778 3.778 0 0 1 16.576 1.5ZM9 4.5V6H7.5V4.5H9Zm0 3V9H7.5V7.5H9Z",
  fill: "#fff"
})));
export default SvgCouponSmall;